import React, { ComponentType } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { checkIsFilmmakersProfile } from "shared-auth";
import { VIEW_PIN_PATTERN } from "pages/MainPage/MainPageWrapper";
import { CommonErrorPopup } from "component-library";
import { useTranslation } from "i18n";

interface IComponentProps {
  nonRestrictedPaths?: string[];
}

export default function withPathsFilmmakersAccessRestriction<
  T extends IComponentProps,
>(nonRestrictedPaths?: string[]) {
  return function (WrappedComponent: ComponentType<T>) {
    return (props: T) => {
      const { t } = useTranslation();
      const { goBack } = useHistory();
      const location = useLocation();
      const isFilmmakerProfile = checkIsFilmmakersProfile();
      const isViewPinPage = Boolean(
        window.location.pathname.match(VIEW_PIN_PATTERN)
      );

      if (
        isFilmmakerProfile &&
        !isViewPinPage &&
        !nonRestrictedPaths?.includes(location.pathname)
      ) {
        return (
          <CommonErrorPopup
            errorStatusCode={403}
            popupProps={{
              close: goBack,
            }}
            alertMessageProps={{
              buttons: [
                {
                  name: t("common:button.label.close"),
                  type: "primary",
                  click: goBack,
                },
              ],
            }}
          />
        );
      }

      return <WrappedComponent {...props} />;
    };
  };
}
